export const openCart = () => {
  document.body.classList.add('mini-cart-is-visible')

  setTimeout(() => {
    document.querySelector('html').classList.add('overflow-hidden')
    document.body.classList.add('mini-cart-is-active')
    document.querySelector('.js-mega-menu-overlay').classList.add('active')
  });
}